// THIS IS SAMPLE CODE ONLY - NOT MEANT FOR PRODUCTION USE
import { BlobServiceClient } from '@azure/storage-blob';


// Blob service sas url https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/?sv=2021-06-08&ss=b&srt=sco&sp=rwdlactfx&se=2027-08-18T08:53:59Z&st=2023-01-10T01:53:59Z&spr=https&sig=BeQOIK1BhsRWqZYgdjozYmV1MqYA9FLXhLTDN15bR4o%3D
// connection string = BlobEndpoint=https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/;QueueEndpoint=https://ertools.queue.core.windows.net/;FileEndpoint=https://ertools.file.core.windows.net/;TableEndpoint=https://ertools.table.core.windows.net/;SharedAccessSignature=sv=2021-06-08&ss=b&srt=sco&sp=rwdlactfx&se=2027-08-18T08:53:59Z&st=2023-01-10T01:53:59Z&spr=https&sig=BeQOIK1BhsRWqZYgdjozYmV1MqYA9FLXhLTDN15bR4o%3D
//https://learn.microsoft.com/en-us/azure/developer/javascript/tutorial/browser-file-upload-azure-storage-blob

const sasToken = "sv=2021-06-08&ss=b&srt=sco&sp=rwdlactfx&se=2027-08-18T08:53:59Z&st=2023-01-10T01:53:59Z&spr=https&sig=BeQOIK1BhsRWqZYgdjozYmV1MqYA9FLXhLTDN15bR4o%3D"; // Fill string with your SAS token

const storageAccountName = "ertools"; // Fill string with your Storage resource name

// Feature flag - disable storage feature to app if not configured
export const isStorageConfigured = () => {
    return !((!storageAccountName || !sasToken));
};

// return list of blobs in container to display
const getBlobsInContainer = async (containerClient, containerName) => {
    const returnedBlobUrls = [];

    // get list of blobs in container
    // eslint-disable-next-line
    for await (const blob of containerClient.listBlobsFlat()) {
        // if image is public, just construct URL
        returnedBlobUrls.push(
            `https://${storageAccountName}.blob.core.windows.net/${containerName}/${blob.name}`
        );
    }

    return returnedBlobUrls;
};


const createBlobInContainer = async (containerClient, file) => {
    const blobClient = containerClient.getBlockBlobClient(file.name);

    const options = { blobHTTPHeaders: { blobContentType: file.type } };

    await blobClient.uploadBrowserData(file, options);
    await blobClient.setMetadata({ UserName: 'shubham' });
};

const uploadFileToBlob = async (file, containerName) => {
    if (!file) return [];

    const blobService = new BlobServiceClient(
        `https://${storageAccountName}.blob.core.windows.net/?${sasToken}`
    );
    const containerClient = blobService.getContainerClient(containerName);

    await createBlobInContainer(containerClient, file);

    //return getBlobsInContainer(containerClient);
};

// </snippet_uploadFileToBlob>

export default uploadFileToBlob;